import constate from 'constate';
import { type Components, type Options } from 'react-markdown';

interface UseMarkdownProps {
  extraComponents?: Components;
  extraRemarkPlugins: NonNullable<Options['remarkPlugins']>;
}

// Explicitly annotate return type to workaround a type portability issue
// https://github.com/microsoft/TypeScript/issues/47663#issuecomment-1519138189
function useMarkdown(props: Partial<UseMarkdownProps>): UseMarkdownProps {
  return {
    ...props,
    extraRemarkPlugins: props.extraRemarkPlugins ?? [],
  };
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore-error FIXME: workaround for busted types
export const [MarkdownProvider, useMarkdownContext] = constate(useMarkdown);
